import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const AccessCard = ({ roles }) => {

    return (
        <M_Table entityName={'AccessCard'} filtersOnTable rolePermissions={roles} />
    )
}